import { AdminApi } from 'stylemix-vue-admin'

export default class VehicleAdditionalServicePricesApi extends AdminApi {
  constructor(parameters = {}) {
    super('vehicles/additional-service-prices', parameters)
  }

  fetchForm() {
    return this.submit('get', `/${this.endpoint}`)
  }

  save(payload) {
    return this.submit('put', `/${this.endpoint}`, payload)
  }
}
